import React from 'react';
import './UIVillageView.css';
import playstoreBadge from "../../../assets/download_badge_android.png";
import appstoreBadge from "../../../assets/download_badge_ios.svg";
import UIFooter from "../_commons/Footer/UIFooter";
import UIBrand from "../_commons/Brand/UIBrand";

export default class UIVillageView extends React.Component {

    componentDidMount() {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }

    render() {
        const { village, onBack } = this.props;
        if (!village) return null;

        return (
            <div className="UIVillageView">

                {/* ===== HEADER (ohne Menü-Links) ===== */}
                <header className="village-header">
                    <div className="village-header-inner">
                        <UIBrand onClick={onBack} />
                        <button className="village-back-btn" onClick={onBack}>
                            ← Zurück
                        </button>
                    </div>
                </header>

                {/* ===== HERO BILD ===== */}
                <div className="village-hero">
                    <img src={village.img} alt={village.title} />
                    <div className="village-hero-overlay">
                        <div className="village-hero-overlay-inner">
                            <h1>{village.title}</h1>
                            <span className={`village-badge ${village.available ? 'available' : 'preparing'}`}>
                                {village.available ? '✓ Verfügbar' : '⏳ In Vorbereitung'}
                            </span>
                        </div>
                    </div>
                </div>

                {/* ===== APP INFO ===== */}
                <section className="village-info">
                    <div className="village-info-inner">
                        <h2>Dorffuchs für {village.title}</h2>
                        <p>
                            Entdecke alles über {village.title} in der Dorffuchs-App –
                            Geschichte, Neuigkeiten, Veranstaltungen und das Bürgerforum,
                            kostenlos und werbefrei direkt auf deinem Smartphone.
                        </p>

                        {village.available ? (
                            <div className="village-store-badges">
                                {village.googlePlayUrl && (
                                    <a
                                        href={village.googlePlayUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="village-store-badge"
                                    >
                                        <img src={playstoreBadge} alt="Jetzt bei Google Play" />
                                    </a>
                                )}
                                {village.appStoreUrl && (
                                    <a
                                        href={village.appStoreUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="village-store-badge"
                                    >
                                        <img src={appstoreBadge} alt="Laden im App Store" />
                                    </a>
                                )}
                            </div>
                        ) : (
                            <div className="village-coming-soon">
                                <p>⏳ Diese Gemeinde ist noch in Vorbereitung. Schau bald wieder vorbei!</p>
                            </div>
                        )}
                    </div>
                </section>

                {/* ===== FOOTER ===== */}
                <UIFooter />

            </div>
        );
    }
}

